import { SET_PROJECT_STATUS_ISVISIBLE } from './constants';

export const setProjectStatusIsVisible = isVisible => ({
    type: SET_PROJECT_STATUS_ISVISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectStatus/actions.js